// extracted by mini-css-extract-plugin
module.exports = {"open":"MapMarkerDonut_open__2uLNs","close":"MapMarkerDonut_close__XpTBP"};